module.exports = __webpack_public_path__ + "img/pencil-alt-disable.967dfce5.svg";